import { Stack, Typography } from '@mui/material';
import React from 'react';
import { Pagination } from 'new/elements/Pagination';
import { CapsulesTable } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTable';
import type {
  CapsuleRowMenuAction,
  CapsuleTableRow,
} from 'new/modules/settings/capsules/viewModels/capsulesTableViewModel';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableRegion/CapsulesTableRegion.module.scss';

export interface CapsulesTableRegionProps {
  rows: CapsuleTableRow[];
  onRowClick?: (row: CapsuleTableRow) => void;
  onRowMenuAction?: (action: CapsuleRowMenuAction, row: CapsuleTableRow) => void;
  showRowActions?: boolean;
  showFetchingHint: boolean;
  showPagination?: boolean;
  page?: number;
  pageCount?: number;
  onPageChange?: (event: React.ChangeEvent<unknown>, value: number) => void;
}

export const CapsulesTableRegion: React.FC<CapsulesTableRegionProps> = ({
  rows,
  onRowClick,
  onRowMenuAction,
  showRowActions = true,
  showFetchingHint,
  showPagination,
  page,
  pageCount,
  onPageChange,
}) => {
  return (
    <div className={styles.tableRegion}>
      {showFetchingHint && (
        <Typography variant="caption" className={styles.fetchingHint}>
          Updating…
        </Typography>
      )}

      <CapsulesTable
        rows={rows}
        onRowClick={onRowClick}
        onRowMenuAction={onRowMenuAction}
        showRowActions={showRowActions}
      />

      {showPagination ? (
        <Stack
          className={styles.pagination}
          component="nav"
          direction="row"
          justifyContent="center"
          width="100%"
          aria-label="Capsules list pages"
        >
          <Pagination count={pageCount} page={page} onChange={onPageChange} shape="circular" />
        </Stack>
      ) : (
        <div className={styles.padding} />
      )}
    </div>
  );
};
